module.exports = new __parcel__URL__("the-apple-ii-age.3967eaa8.jpg").toString();